var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 15,
    fill: "#F2F2FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.7094 14.5036L32.4955 29.3441L44.1386 29.3785L28.2901 49.497L31.5041 33.1701L19.8617 33.1344L35.7094 14.5036ZM35.7116 12.0001C35.6347 12.0001 35.5578 12.0025 35.4823 12.0075C34.9795 12.0432 34.6462 12.1909 34.251 12.4244C34.0284 12.5548 33.8278 12.712 33.6549 12.8913C33.603 12.9451 33.554 13.0011 33.5081 13.059L17.5464 31.6248C16.9162 32.384 16.8236 33.3861 17.3079 34.2235C17.7914 35.0609 18.7692 35.5917 19.841 35.5986L28.0637 35.6512L25.4785 49.037C25.2328 50.1874 25.9307 51.3341 27.1592 51.796C27.5162 51.9308 27.9008 52.0002 28.2894 52C29.1846 52 29.9202 51.632 30.4722 50.9673L46.4538 30.8487C47.0841 30.0894 47.176 29.0861 46.6924 28.2499C46.2089 27.4125 45.2311 26.8817 44.1592 26.8749L35.9366 26.8624L38.494 15.0925C38.5482 14.8998 38.5755 14.702 38.5752 14.5036C38.5752 13.1491 37.3481 12.0451 35.8127 12.0013C35.7786 12 35.745 12 35.7116 12L35.7116 12.0001Z",
    fill: "#7255FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_3",
    x: 13,
    y: 12,
    width: 38,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_3",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.09ed8ff174a21818dafa2ef6cc9c1ac9.svg";
export { ForwardRef as ReactComponent };